import React from 'react';

import { numberWithComma } from '@commonTuna/react/utils/NumberWithComma/NumberWithComma';

import Stars from '@app/components/UI/Stars/Stars';

interface Props {
	averageReviewRate: number;
	totalReviewCount: number;
	className?: string;
	showAverageReviewRate?: boolean;
	starsClassName?: string;
}

const Rate: React.FC<Props> = (props) => {
	const {
		averageReviewRate,
		totalReviewCount,
		className = '',
		showAverageReviewRate = true,
		starsClassName = '',
	} = props;

	return <div className={`doctor-rate ${className}`}>
		{totalReviewCount > 0 ? <>
			<strong className={`stars ${starsClassName}`}>
				<Stars value={averageReviewRate || 0} />
			</strong>
			{' '}
			<span>
				{showAverageReviewRate ? <>
					{numberWithComma(averageReviewRate)}
					{' '}
				</> : null}
				(
				{totalReviewCount}
				)
			</span>
		</> : <></>}
	</div>;
};

export default Rate;
